<template>
  <div class="wrap physical-stores-wrap flex-column">
    <div class="head verticalM">
      <div class="verticalM-box address"><span class="ellipsis" @click="addressPopup=true;isAddress=true" v-model="addressMsgShow">{{addressMsgShow}}</span></div>
      <div class="verticalM-box brand"><span class="ellipsis" @click="addressPopup=true;isAddress=false;">{{brandName}}</span></div>
    </div>
    <!-- 地图 -->
    <div class="flex-item map" v-if="amap">
            <el-amap vid="amapDemo" :center="amap.center" :map-manager="amap.amapManager" :zoom="amap.zoom" :events="amap.events" class="amap-demo">
              </el-amap>
    </div>
    <!-- 选择地区 -->
    <mu-popup position="bottom" popupClass="popup-bottom physical-popup" :open="addressPopup" @close="addressPopup= false">
      <h3>{{isAddress ? '所在地区' : '选择品牌'}}<span @click="addressPopup=false"></span></h3>
      <div class="popup-content">
        <!-- 地址选择 -->
        <div class="chooseList forbid-sel-text" v-if="isAddress" :class="{'chooseTwo':shoWOr==2,'chooseOne':shoWOr==1}">
          <div class="pShow">
            <samp class="sampOne" @click="clickProvince(1)" v-if="shoWOr<=1">请选择</samp>
            <samp @click="clickProvince(2)" v-if="shoWOr>=2">{{addressProvince}}</samp>
            <samp @click="clickProvince(2)" v-if="shoWOr>=3">{{cityNameShow}}</samp>
            <samp class="sampTwo" v-if="shoWOr==2">请选择</samp>
            <!-- <samp @click="clickProvince(2)" v-if="shoWOr<=3">{{cityNameShow}}</samp> -->
            <!-- <samp @click="clickProvince(3)" v-if="shoWOr==3">{{addressProvince}}</samp> -->
          </div>
         <!-- 省 -->
          <div class="chooseProvince" v-if="shoWOr==1">
            <span v-for="provinceShow in arealistMsg" @click="shooseProvince(provinceShow.areaId,provinceShow.areaName)">{{provinceShow.areaName}}</span>
          </div>
          <!-- 市 -->
          <div class="chooseProvince" v-if="shoWOr==2">
            <span v-for="cityShow in cityListShow" @click="shooseCity(cityShow.areaId,cityShow.areaName)" :class="{'chooseCityStyle':chooseCityId==cityShow.areaId}"> {{cityShow.areaName}}</span>
          </div>
          <!-- 区域 -->
          <div class="chooseProvince" v-if="shoWOr==3">
            <span v-for="areaListShow in areaAddressMsg" @click="shooseArea(areaListShow.areaId,areaListShow.areaName)" :class="{'chooseCityStyle':chooseAreaId==areaListShow.areaId}"> {{areaListShow.areaName}}</span>
          </div>
          <!-- 街道/镇 -->
          <div class="chooseProvince" v-if="shoWOr==4">
            <span v-for="streetListShow in getStreetMsgList" @click="shooseStreet(streetListShow.areaId,streetListShow.areaName)" :class="{'chooseCityStyle':chooseStreetId==streetListShow.areaId}"> {{streetListShow.areaName}}</span>
          </div>
        </div>
        <!-- 店铺选择 -->
        <div v-if="!isAddress">
          <mu-checkbox name="group" :labelLeft="true" v-for="(brand,index) in Brands"  :nativeValue="brand.linkTarget"  :label="brand.linkName" class="demo-checkbox" :key="brand.linkTarget" v-model="brand.selected"  @change="selBrand($event,index)"/>
        </div>
      </div>
      <div class="bottom-btn-box">
        <div class="bottom-full-button">
          <mu-raised-button label="确认" fullWidth primary @click="adressFirm" />
        </div>
      </div>
    </mu-popup>
  </div>
</template>
<script type="text/javascript">
import { mapActions } from 'vuex';
import { AMapManager } from 'vue-amap';
const address = {
  '北京': ['东城区', '海淀区'],
  '广东': ['广州', '深圳', '珠海', '汕头', '韶关', '佛山', '江门', '湛江'],
  '上海': ['上海'],
  '天津': ['天津'],
  '重庆': ['重庆', '渝北'],
};
export default {

  data() {
    return {
      currentAddress: {
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        area: '',
        townId: '',
        town: '',
        address: '',
        postCode: '',
        consignee: '',
        mobile: '',
        isDefault: 0
      }, //当前地址信息
      addressMsgShow: '请选择地区', //页面展示的值
      addressProvince: '', //展示省份
      addressCity: '', //展示城市
      chooseCityId: '', //选中城市id
      chooseAreaId: '', //选中的区域id
      chooseStreetId: '', //获取的街道id
      arealistMsg: [], //当前获取到的省份信息
      cityListShow: [], //获取到的城市信息
      areaAddressMsg: [], //获取到城镇信息
      bottomPopup: false, //选择地址弹框
      chooseBox: true, //选择地址弹框
      shoWOr: 1, //初始展示省份一级
      errorShow: 0, //错误信息提示
      toast2: false, //手机号码验证
      messageShow: '', //提示信息
      cityNameShow: '', //城市展示
      areaNameShow: '', //区域名
      getStreetMsgList: '', //最后街道信息
      streetNameShow: '', //街道信息
      addressCode: 0,
      addressPopup: false,
      isAddress: false, //是否是选择地区
      /*以下为地图板块*/
      amap: null,
      lat: null,
      lng: null,

      //品牌
      Brands:[],//品牌列表
      brandId:'',//选中的品牌id
      brandName:'全部品牌',//品牌名称
      temp:{},//临时变量
    }
  },
  created() {
    this.getBrands().then(res => {  
      res.forEach(item => {
        item.selected = false ;
      })
      this.Brands = res;
    })

  },
  methods: {
    ...mapActions({
      listAreaMsg: 'listAreaMsg', //获取地域列表
      pageDealerStore: 'pageDealerStore', //分页获取实体门店信息
      getBrands:'getBrands',
    }),
    selBrand(event,index){
      //全部置为  未选中状态
      this.Brands.forEach(item => {
        item.selected = false ;
      })
      //当前为选中，记录品牌id
      if(event){
        this.brandId = this.Brands[index].linkTarget;
        this.brandName = this.Brands[index].linkName;
      }else{
        this.brandId = '';
        this.brandName = '全部品牌'
      }
      this.Brands[index].selected = event;
    },
    //获取地图内容
    getAmapContent() {
      let vm = this;
      let amap = {
        resizeEnable: true,
        zoom: 1,
        center: [121.59996, 31.197646],
        markers: [],
        events: {
          init(map) {
            AMapUI.loadUI(['misc/MarkerList', 'overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function(MarkerList, SimpleMarker, SimpleInfoWindow) {
              var $ = MarkerList.utils.$;

              /*var defaultIconStyle = 'red'; //默认的图标样式*/

              vm.markerList = new MarkerList({
                map: map,
                //ListElement对应的父节点或者ID
                //listContainer: "myList", //document.getElementById("myList"),
                //选中后显示

                //从数据中读取位置, 返回lngLat
                getPosition: function(item) {
                  return [item.longitude, item.latitude];
                },
                //数据ID，如果不提供，默认使用数组索引，即index
                getDataId: function(item, index) {
                  return item.id;
                },
                getCityCode: function(item) {
                  return item.cityCode;
                },
                getInfoWindow: function(data, context, recycledInfoWindow) {
                  var innerHTML = MarkerList.utils.template(
                    '<div class="info-title"><%- data.storeName %></div>' +
                    '<div class="info-content">' +
                    '<% if(data.relaPhone ){ %>' +
                    '        <p class="info-item phone"><%- data.relaPhone %></p>' +
                    '<% } %>' +
                    '<p class="info-item address"><%- data.address %></p>' +
                    '</div>'+
                    '<a class="info-goHere" href="http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:'+data.latitude+','+data.longitude+';title:'+data.address+';addr:'+data.address+'&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"></a>', {
                      data: data
                    });

                  var infowindow = new AMap.InfoWindow({
                    placeSearch: true,
                    asOrigin: true,
                    asDestination: true,
                    content: innerHTML,
                    offset: new AMap.Pixel(0, -30)
                  });
                  return infowindow;
                },
                //构造marker用的options对象, content和title支持模板，也可以是函数，返回marker实例，或者返回options对象
                getMarker: function(data, context, recycledMarker) {
                  var label = 1;
                  label += context.index;
                  if (recycledMarker) {
                    recycledMarker.setIconLabel(label);
                    return;
                  }

                  return new SimpleMarker({
                    containerClassNames: 'my-marker',
                    iconStyle: vm.defaultIconStyle,
                    iconLabel: label
                  });
                },
                //构造列表元素，与getMarker类似，可以是函数，返回一个dom元素，或者模板 html string
                getListElement: function(data, context, recycledListElement) {
                  var label = 1;
                  label += context.index;
                  //使用模板创建
                  var innerHTML = MarkerList.utils.template(
                    '<span class="poibox-label"><%- label %></span>' +
                    '<div class="poi-info-left">' +
                    '    <h3 class="poi-title">' +
                    '        <%- data.storeName %>' +
                    '    </h3>' +
                    '    <div class="poi-info">' +
                    '        <p class="poi-addr">地址：<%- data.address %></p>' +
                    '<% if(data.relaPhone ){ %>' +
                    '        <p class="poi-addr">电话：<%- data.relaPhone %></p>' +
                    '<% } %>' +
                    '    </div>' +
                    '</div>' +
                    '<div class="clear"></div>', {
                      data: data,
                      label: label
                    });

                  if (recycledListElement) {
                    recycledListElement.innerHTML = innerHTML;
                    return recycledListElement;
                  }

                  return '<li class="poibox">' +
                    innerHTML +
                    '</li>';
                },
                //列表节点上监听的事件
                listElementEvents: ['click', 'mouseenter', 'mouseleave'],
                //marker上监听的事件
                markerEvents: ['click', 'mouseover', 'mouseout'],
                //makeSelectedEvents:false,
                selectedClassNames: 'selected',
                autoSetFitView: true
              });

//加载地图，调用浏览器定位服务
            var geolocation;
            map.plugin('AMap.Geolocation', function() {
                geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true,//是否使用高精度定位，默认:true
                    timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                    buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: true,      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    buttonPosition:'RB'
                });
                map.addControl(geolocation);
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
                AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
            });

            //解析定位结果
            function onComplete(data) {
              console.log("lng",data.position.getLng())
              let positionLists = [];
              let positionList = {
                longitude: data.position.getLng(),
                latitude: data.position.getLat()
              }

              vm.lng = data.position.getLng();
                    vm.lat = data.position.getLat();
                      //地图显示当前城市
                      let params = {
                        mapType: 2,
                        longitude: vm.currentAddress.provinceId ? "" : data.position.getLng(),
                        latitude: vm.currentAddress.cityId ? "" : data.position.getLat(),
                        provinceCode: '',
                        cityCode: '',
                        areaCode: '',
                        brandId: '',
                        storeId: vm.storeId || '',
                        goodsId: vm.goodsId || '',
                        provinceId: vm.currentAddress.provinceId || "",
                        cityId: vm.currentAddress.cityId || "",
                        areaId: vm.currentAddress.areaId || "",
                      }
                      vm.pageDealerStore([params, 1, 20]).then(res => {
                        vm.markerList.render(res.result);
                      })

              // positionLists.push(positionList);
              // vm.markerList.render(positionLists);
            }
            //解析定位错误信息
            function onError(data) {
                    //实例化城市查询类
                    var citysearch = new AMap.CitySearch();
                    // var city = "重庆"
                    //自动获取用户IP，返回当前城市
                    citysearch.getLocalCity(function(status, result) {
                      if (status === 'complete' && result.info === 'OK') {
                        if (result && result.city && result.bounds) {
                          vm.lng = result.bounds.eb.lng;
                          vm.lat = result.bounds.eb.lat;
                          //地图显示当前城市
                          let params = {
                            mapType: 2,
                            longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
                            latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
                            provinceCode: '',
                            cityCode: '',
                            areaCode: '',
                            brandId: '',
                            storeId: vm.storeId || '',
                            goodsId: vm.goodsId || '',
                            provinceId: vm.currentAddress.provinceId || "",
                            cityId: vm.currentAddress.cityId || "",
                            areaId: vm.currentAddress.areaId || "",
                          }
                          vm.pageDealerStore([params, 1, 20]).then(res => {
                            vm.markerList.render(res.result);
                          })
                        }
                      }
                    });
              }
                });
      
              // //实例化城市查询类
              // var citysearch = new AMap.CitySearch();
              // var city = "重庆"
              // //自动获取用户IP，返回当前城市
              // citysearch.getLocalCity(function(status, result) {
              //   if (status === 'complete' && result.info === 'OK') {
              //     if (result && result.city && result.bounds) {
              //       vm.lng = result.bounds.eb.lng;
              //       vm.lat = result.bounds.eb.lat;
              //       //地图显示当前城市
              //       let params = {
              //         mapType: 2,
              //         longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
              //         latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
              //         provinceCode: '',
              //         cityCode: '',
              //         areaCode: '',
              //         brandId: vm.brandId || '',
              //         storeId: '',
              //         goodsId: '',
              //         provinceId: vm.currentAddress.provinceId || "",
              //         cityId: vm.currentAddress.cityId || "",
              //         areaId: vm.currentAddress.areaId || "",
              //       }
              //       vm.pageDealerStore([params, 1, 20]).then(res => {
              //         vm.markerList.render(res.result);
              //       })
              //     }
              //   }
              // });
            // });
          }
        }
      }
      this.amap = amap;
    },
    //获取实体门店数据
    getPageDealerStore(lat, lng) {
      let params = {
        mapType: 2,
        longitude: this.lng || "",
        latitude: this.lat || "",
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        brandId: this.brandId || '',
        storeId: '',
        goodsId:  '',
        provinceId: this.currentAddress.provinceId || "",
        cityId: this.currentAddress.cityId || "",
        areaId: this.currentAddress.areaId || "",
      }
      this.pageDealerStore([params, 1, 20]).then(res => {
        this.markerList.render(res.result);
      })
    },
    //地址看确认
    adressFirm(){
        if(this.isAddress){
          this.brandId = '';
          this.brandName = '全部品牌';
          this.Brands.forEach(item => {
            item.selected = false ;
          })
        }
        this.addressPopup= false;
        this.isAddress=true;
        //this.getAmapContent();
        this.getPageDealerStore();
      },
      //地址出现弹框
    clickProvince(areaId) {
      this.addressMsgShow = '请选择区域';
      this.addressProvince = '';
      this.cityNameShow = '';
      this.currentAddress.province = '';
      this.currentAddress.provinceId = '';
      this.currentAddress.city = '';
      this.currentAddress.cityId = '';
      this.currentAddress.areaId = '';
      this.currentAddress.area = '';
      this.currentAddress.townId = '';
      this.currentAddress.town = '';
      this.shoWOr = 1;
    },
    // 点击省出现下级
    shooseProvince(provinceId, provinceName) {
      //this.clickProvince();
      this.shoWOr = 2;
      this.getCityListShow(provinceId); //获取城市列表
      this.currentAddress.provinceId = provinceId; //保存id
      this.currentAddress.province = provinceName; //保存名字
      this.addressProvince = provinceName; //名字在页面展示
      this.addressMsgShow = provinceName; //选择框展示
    },
    //点击城市出现下级
    shooseCity(cityId, cityName) {
      this.getTownMsg(cityId); //获取城镇信息
      //setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
      //this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
      this.currentAddress.city = cityName; //保存城市名字
      this.cityNameShow = cityName; //展示城市名字
      this.currentAddress.cityId = cityId; //保存城市id
      this.chooseCityId = cityId; //选中城市的id
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow;
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
        if (this.areaAddressMsg.length == 0) {
          this.addressMsgShow = this.addressProvince + '/' +this.cityNameShow; //选择框展示城市名字
          this.shoWOr = 2; //关闭地址选择框
          return;
        } else if (this.areaAddressMsg.length != 0) {
          this.shoWOr = 3;
        }
      })
    },
    //点击区域出现下一级
    shooseArea(areaId, areaName) {
      this.currentAddress.areaId = areaId; //保存的区域id
      this.chooseAreaId = areaId; //保存的id
      this.currentAddress.area = areaName; //保存地址名称
      this.areaNameShow = areaName; //展示的街道
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow  + '/' + this.areaNameShow;
      //this.chooseBox = false; //关闭地址框
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
        if (this.getStreetMsgList.length == 0) {
          this.shoWOr = 3;
        } else {
          this.shoWOr = 4;
        }
      })
    },
    //点击街道出现下一级
    shooseStreet(areaId, areaName) {
      this.currentAddress.townId = areaId; //保存的区域id
      this.chooseStreetId = areaId; //保存街道id
      this.currentAddress.town = areaName; //保存地址名称
      this.streetNameShow = areaName; //展示的街道
      //this.chooseBox = false; //关闭地址框
      this.addressMsgShow = this.addressProvince  + '/' + this.cityNameShow  + '/' + this.areaNameShow  + '/' + this.streetNameShow;
      this.listAreaMsg(areaId).then(res => {
        this.lastMsg = res.target;
      })

    },
    //获取区域的列表api
    getAreaMsg(areaId) {
      this.listAreaMsg(areaId).then(res => {
        this.getStreetMsgList = res.target;
      })
    },
    //获取城镇信息api
    getTownMsg(cityId) {
      this.listAreaMsg(cityId).then(res => {
        this.areaAddressMsg = res.target;
      })
    },
    //获取城市的列表api
    getCityListShow(provinceId) {
      this.listAreaMsg(provinceId).then(result => {
        this.cityListShow = result.target;
      })
    },
    //获取省份列表api
    getListAreaMsg(addressCode) {
      this.listAreaMsg(addressCode).then(result => {
        this.arealistMsg = result.target;

      }).catch(error => {})
    },

  },
  mounted() {
    this.getAmapContent();
    //获取地域列表
    this.getListAreaMsg(this.addressCode);
  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/common/sass/mixin.scss';
.physical-stores-wrap {
  .head {
    height: 1.1rem;
    padding: 0 0.35rem;
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
    font-size: 0;
    >.verticalM-box {
      @include font-dpr(12px);
      color: #222222;
      >span {
        display: inline-block;
        height: 0.75rem;
        padding: 0 0.35rem;
        line-height: 0.75rem;
        background: #F3F3F3;
        border: 1px solid #CFCFCF;
        border-radius: 2px;
        vertical-align: top;
        position: relative;
        &:after {
          @include triangle(down, 0.15rem, #999999);
          position: absolute;
          right: 0.35rem;
          top: 50%;
          margin-top: -0.075rem;
        }
      }
      &.address {
        width: 65%;
        >span {
          width: 80%;
          padding-right: 0.6rem;
        }
      }
      &.brand {
        width: 35%;
        >span {
          width: 100%;
        }
      }
    }
  }
  .map {
    position: relative;
    .amap-marker {
      &.selected {
        .amap-simple-marker-icon {
          background: url(/static/images/physical_store_blue2.png) no-repeat center;
          background-size: 0.65rem 0.725rem ;
        }
      }
    }
    .amap-info-content{
      width: 6rem;
    }
    .amap-demo {
      position: absolute;
      display: inline-block;
      width: 100%;
     .amap-simple-marker-icon {
        width: 0.45rem;
        height: 0.625rem;
        background: url(/static/images/physical_store.png) no-repeat center;
        background-size: auto 100% ;
      }
      .amap-simple-marker-style-red {
        width: 0.45rem;
        height: 0.625rem;
        color: #fff;
      }
      .amap-simple-marker-label {
        line-height: 0.55rem;
        color: #fff;
        @include font-dpr(12px);
      }
    }
    .info-title {
      padding: 0.25rem 0.1rem;
      color: #333333;
    }
    .info-goHere{
      display: inline-block;
      width: 1.25rem;
      height: 1.25rem;
      background: url(/static/images/map_here_3x.png) no-repeat center;
      background-size: 100%;
      position: absolute;
      right: 1rem;
      top: -0.5rem;
    }
    .info-item {
      padding: 0.1rem 0rem 0.2rem 0.5rem;
      @include font-dpr(12px);
      color: #989898;
      &.phone {
        background: url(/static/images/map_tel.png) no-repeat 0.1rem 0.2rem;
        background-size: 0.25rem auto;
      }
      &.address {
        background: url(/static/images/map_address.png) no-repeat  0.1rem 0.2rem;
        background-size: 0.3rem auto;
      }
    }
  }
}

//底部全屏 button
.bottom-btn-box {
  .bottom-full-button {
    .mu-raised-button-full {
      @include font-dpr(16px);
      line-height: 1.25rem;
      height: 1.25rem;
      background-image: linear-gradient(-90deg, #FF4901 0%, #FF7701 100%);
    }
  }
}

.physical-popup {
  .popup-content {
    max-height: 6.5rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .chooseList {
      //地址选择
      width: 100%;
      height: 9.5rem;
      overflow: auto;
      >.pShow {
        display: inline-block;
        position: fixed;
        background: #fff;
        width: 100%;
        samp {
          @include font-dpr(14px);
          cursor: pointer;
          line-height: 45px;
          margin: 0px 16px;
        }
      }
      .chooseProvince {
        margin-top: 46px;
        margin-bottom: 95px;
        width: 100%;
        @include font-dpr(14px);
        padding-top: 10px;
        border-top: 1px solid #EAEAEA;
        span {
          display: block;
          @include font-dpr(14px);
          cursor: pointer;
          margin: 9px 0px;
          width: 100%;
          text-align: left;
          text-indent: 14px;
          &.chooseCityStyle {
            color: #e60012;
          }
        }
      }
      &.chooseOne {
        .pShow>samp.sampOne {
          @include font-dpr(14px);
          color: #E60012;
          display: inline-block;
          border-bottom: 1px solid #E60012;
        }
      }
      &.chooseTwo {
        .pShow>samp.sampTwo {
          @include font-dpr(14px);
          color: #E60012;
          display: inline-block;
          border-bottom: 1px solid #E60012;
        }
      }
    }
    .mu-checkbox {
      display: block;
      height: auto;
      line-height: inherit;
      padding: 0.4rem 0.35rem;
      @include bdT(#E5E5E5, top);
      &:first-child {
        &:after {
          display: none;
        }
      }
      .mu-checkbox-wrapper {
        .mu-checkbox-ripple-wrapper {
          width: 1.2rem;
          height: 1.2rem;
          top: 50%;
          right: 0.2rem;
          margin-top: -0.6rem;
          color: #E60012 !important;
        }
        .mu-checkbox-label {
          @include font-dpr(14px);
          color: #333333;
        }
        .mu-checkbox-icon {
          width: 0.45rem;
          height: 0.45rem;
          margin-right: 0.3rem;
          .mu-checkbox-svg-icon {
            height: 0.45rem;
            height: 0.45rem;
          }
          .mu-checkbox-icon-checked {
            color: #E60012;
          }
          .mu-checkbox-icon-uncheck {
            color: #dddddd;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// physicalStores.vue?01bb7b2d